import { ButtonType } from '@ardoq/button';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import type { DropdownConfig } from '@ardoq/view-settings';
import { IconSize } from '@ardoq/icons';
import { SettingsBarPopover } from './SettingsBarPopover';
import { SettingsBarContentPopover } from './SettingsBarContentPopover';

const Dropdown = ({
  iconName,
  label,
  buttonText,
  isKeepOpen = false,
  options,
  isDisabled = false,
  isActive = false,
  className,
  id,
  clickNamespace,
  popoverText,
  popoverContent,
  requestOpen,
  onOpened,
  dropdownSize,
  maxDropdownSize,
  maxDropdownHeight,
}: DropdownConfig) => {
  return (
    <SettingsBarContentPopover popoverContent={popoverContent}>
      <SettingsBarPopover
        popoverText={popoverContent ? undefined : popoverText}
      >
        <ButtonWithDropdown
          className={className}
          options={options}
          // DropdownButton hides the chevron whenever an icon is present, so the
          // text-combo variant omits the icon.
          iconName={buttonText !== undefined ? undefined : iconName}
          iconSize={IconSize.MEDIUM}
          tooltipText={
            popoverText || popoverContent
              ? undefined
              : label /** don't show a tooltip when there's a popover. */
          }
          // In text-combo mode aria-label is the whole accessible name, so keep the
          // visible value in it (WCAG 2.5.3 Label in Name).
          aria-label={
            buttonText !== undefined ? `${label}: ${buttonText}` : label
          }
          isKeepOpen={isKeepOpen}
          isActive={
            isActive &&
            !isDisabled /* active disabled state is possible, but we are not using it. */
          }
          isDisabled={isDisabled}
          data-click-id={id}
          clickNamespace={clickNamespace}
          dropdownSize={dropdownSize}
          minDropdownSize={DropdownSize.S}
          maxDropdownSize={maxDropdownSize ?? DropdownSize.M}
          maxDropdownHeight={maxDropdownHeight}
          requestOpen={requestOpen}
          onMenuOpen={onOpened}
          buttonType={ButtonType.GHOST}
        >
          {buttonText}
        </ButtonWithDropdown>
      </SettingsBarPopover>
    </SettingsBarContentPopover>
  );
};

export { Dropdown };
